import { IModelAnswer, IModelAnswerData,ITableRes } from 'types'

import { baseApi } from './baseApi'

export const modelAnswersAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_modelAnswers: builder.query<ITableRes<IModelAnswer>, {assignment_id: string, params?: any}>({
      query: ({assignment_id, params={} }) => ({
        url: `/assignment-model-answers/${assignment_id}/`,
        params,
      }),
      providesTags: ['model-answers'],
    }),
    GET_modelAnswerById: builder.query<IModelAnswer, {assignment_id: string, id: string}>({
      query: ({assignment_id, id}) => ({
        url: `/assignment-model-answers/${assignment_id}/${id}/`,
      }),
      providesTags: ['model-answer'],
    }),
    POST_modelAnswer: builder.mutation<IModelAnswer, {assignment_id: string, body: IModelAnswerData}>({
      query: ({assignment_id, body}) => ({
        url: `/assignment-model-answers/${assignment_id}/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['model-answers','model-answer'],
    }),
    PATCH_modelAnswer: builder.mutation<IModelAnswer, {assignment_id: string, id: string, body: IModelAnswerData}>({
      query: ({assignment_id, id, body}) => ({
        url: `/assignment-model-answers/${assignment_id}/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['model-answers','model-answer'],
    }),
    DELETE_modelAnswer: builder.mutation<IModelAnswer, {assignment_id: string, id: string}>({
      query: ({assignment_id, id}) => ({
        url: `/assignment-model-answers/${assignment_id}/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['model-answers'],
    }),
  }),
})

export const {
  useGET_modelAnswersQuery,
  useGET_modelAnswerByIdQuery,
  usePOST_modelAnswerMutation,
  usePATCH_modelAnswerMutation,
  useDELETE_modelAnswerMutation,
} = modelAnswersAPI
